module.exports = __webpack_public_path__ + "img/about6.4d9c733d.png";